import DocumentsTable from './documents-table';

export default DocumentsTable;
